import React from 'react'
import { StylesProvider, createGenerateClassName } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'

const generateClassName = createGenerateClassName({
    disableGlobal: true,
    productionPrefix: 'mui',
})

const ThemeWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <StylesProvider injectFirst generateClassName={generateClassName}>
        <CssBaseline />
        {children}
    </StylesProvider>
)

export default ThemeWrapper
